import * as actionTypes from './actionTypes'

export function updateTransportationField(field, payload) {
  return {
    type: actionTypes.UPDATE_TRANSPORTATION_FIELD,
    payload,
    field
  }
}
export function updateTransportDate(object, field, value) {
  return {
    type: actionTypes.UPDATE_TRANSPORTATION_DATE,
    value,
    field,
    object
  }
}

export function saveTransportationField(field, payload) {
  return {
    type: actionTypes.SAVE_TRANSPORTATION_FIELD,
    field,
    payload
  }
}

export function saveTransportationDateField(field, payload) {
  return {
    type: actionTypes.SAVE_TRANSPORTATION_DATE_FIELD,
    payload,
    field
  }
}

export function updateTransportationErrorWarning(warnings) {
  return {
    type: actionTypes.UPDATE_TRANSPORTATION_INFO_WARNING,
    warnings
  }
}
